<template>
	<md-dialog :md-active="show" style="font-family: 'Montserrat', sans-serif; z-index: 1000">
		<div style="width: 500px; overflow-y: auto">
			<div class="dialog-header">
				<span style="margin-top: auto; margin-bottom: auto; font-size: 18px">{{ $t("versions") }}</span>
				<div style="margin-left: auto; margin-right: 0">
					<md-button @click="$emit('close')" class="md-icon-button" style="margin-right: -5px">
						<md-icon style="color: white">close</md-icon>
					</md-button>
				</div>
			</div>
			<div class="dialog-body">
				<div class="container">
					<div v-for="(version, index) in statusesPerVersions" :key="index" id="versioning">
						<div style="margin-right: 25px">
							<el-popconfirm
								:confirm-button-text="$t('confirm')"
								:cancel-button-text="$t('cancel')"
								icon="el-icon-info"
								icon-color="red"
								:title="$t('delete-version')"
								@onConfirm="()=>{
										statusesPerVersions.splice(index, 1)
									deleteDocVersion(version.Id, version.Version)
								}"
							>
								<el-button slot="reference" icon="el-icon-delete" type="danger" plain circle />
							</el-popconfirm>
						</div>
						<div style="margin-right: 25px">
							<span class="md-body-2"
								><strong>{{ $t("version-number") }} {{ version.Version }}</strong></span
							>
							<p class="md-body-2">
								{{ $t("last-update") }}
								{{ moment(version.updated_at.substring(0, 19) + "+02:00").format("lll") }} -
								{{ moment(version.updated_at.substring(0, 19) + "+02:00").fromNow() }}
							</p>
						</div>
						<div>
							<el-switch
								@change="
									val => {
										changedValVers(val, version.Id)
									}
								"
								style="display: block"
								v-model="version.Status"
								active-color="#13ce66"
								inactive-color="#ff4949"
								:active-text="$t('published')"
								:inactive-text="$t('draft-inactive')"
								active-value="published"
								inactive-value="draft"
							/>
						</div>
					</div>
				</div>
			</div>
			<div class="dialog-footer" style="width: 100%">
				<div style="margin-left: auto; margin-right: 0">
					<md-button class="cancel" @click="$emit('close')">
						{{ $t("close") }}
					</md-button>
				</div>
			</div>
		</div>
	</md-dialog>
</template>

<script>
import axios from "axios"

export default {
	name: "versions-modal",
	props: ["show", "statusesPerVersions"],
	methods: {
		changedValVers(value, idVers) {
			if (value == "draft") {
				this.$notification("warning", this.$t("warning"), this.$t("version-delete-warning"))
			} else {
				this.statusesPerVersions.forEach(element => {
					if (element.Id != idVers && element.Status != "draft") {
						element.Status = "draft"
					}
				})
			}
			const element = this.statusesPerVersions.find(e => e.Id == idVers)

			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/flowchart/setStatus",
					{ id: element.Id, status: value },
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					this.$notification("success", this.$t("status-saved"), "", 4500)
					if (this.$route.params.id) {
						this.$emit("refresh", this.$route.params.id)
					} else {
						this.$emit("refresh", undefined)
					}
				})
				.catch(err => {
					this.$notification("warning", this.$t("warning"), this.$t("generic-error-msg"))
				})
		},
		deleteDocVersion(idx, version_id) {
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/flowchart/deleteDocVersion",
					{
						id: idx,
						version: Number(version_id)
					},
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					this.$notification("success", this.$t("deleted-successfully"), "", 4500)
				})
				.catch(err => {
					this.$notification("warning", this.$t("warning"), this.$t("delete-error"))
				})
		}
	}
}
</script>
<style lang="scss">
@import "@/assets/scss/documents.scss";

#versioning {
	display: inline-flex;
	width: 100%;
	flex-direction: row;
	align-self: center;
	align-items: center;
	align-content: center;
	border-bottom: 1px solid #f2f2f2;
}
</style>
